module.exports = __webpack_public_path__ + "static/media/package-basic.05599a23.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/package-basic.svg
// module id = 123
// module chunks = 0